import classcat from "classcat";
import React from "react";

import { Step } from "@is/types";

import css from "./Stepper.module.css";
import useManageStepper from "./hooks/useManageStepper";

type Props = {
  steps: Step[];
  currentStepIndex: number;
  className?: string;
  onStepChange?: (stepIndex: number) => void;
};

const Stepper = ({
  steps,
  currentStepIndex,
  className,
  onStepChange,
}: Props) => {
  const { hasLabels, handleStepClick } = useManageStepper({
    onStepChange,
    steps,
  });

  return (
    <div
      className={classcat([
        css.container,
        { [css.labelMargin]: hasLabels },
        className,
      ])}
    >
      {steps.map((step, index) => (
        <div
          key={index}
          data-state={index === currentStepIndex ? "active" : "inactive"}
          className={classcat([
            css.step,
            { [css.active]: index === currentStepIndex },
          ])}
          onClick={handleStepClick(index)}
        >
          {index + 1}
          {step.label && (
            <span className={classcat(["text-label-base", css.stepLabel])}>
              {step.label}
            </span>
          )}
        </div>
      ))}
      <div className={css.stepsConnector} />
    </div>
  );
};

export default Stepper;
